import { Button, Card, Space, Tag, Typography } from 'antd';

const { Text } = Typography;

export type BuildingFloorItem = {
  id: string;
  name: string;
  objectCount: number;
  displayOrder?: number | null;
};

export type BuildingFloorNavigatorProps = {
  buildingName: string;
  floors: BuildingFloorItem[];
  activeFloorId: string | null;
  onSelectFloor: (floorId: string) => void;
};

export function BuildingFloorNavigator({
  buildingName,
  floors,
  activeFloorId,
  onSelectFloor,
}: BuildingFloorNavigatorProps) {
  const getFloorLabel = (displayOrder: number | null | undefined, fallbackIndex: number): string => {
    const value =
      typeof displayOrder === 'number' && Number.isFinite(displayOrder) ? displayOrder : fallbackIndex + 1;
    if (value < 0) {
      return `B${Math.abs(value)}F`;
    }
    if (value >= 1000) {
      return 'RF';
    }
    return `${value}F`;
  };

  return (
    <Card
      size="small"
      title="フロア"
      styles={{ body: { padding: 10 } }}
      extra={<Text type="secondary" style={{ fontSize: 12 }}>{buildingName}</Text>}
    >
      {floors.length === 0 ? (
        <Text type="secondary">フロアがありません</Text>
      ) : (
        <Space direction="vertical" style={{ width: '100%' }} size={8}>
          {floors.map((floor, index) => {
            const active = floor.id === activeFloorId;
            const floorLabel = getFloorLabel(floor.displayOrder, index);
            return (
              <Button
                key={floor.id}
                type={active ? 'primary' : 'default'}
                block
                onClick={() => onSelectFloor(floor.id)}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <Space size={6} style={{ minWidth: 0 }}>
                  <Tag color="purple" style={{ margin: 0 }}>
                    {floorLabel}
                  </Tag>
                  <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{floor.name}</span>
                </Space>
                {floor.objectCount > 0 && (
                  <Tag
                    color="geekblue"
                    style={{ marginInlineStart: 8, marginInlineEnd: 0 }}
                  >
                    {floor.objectCount > 99 ? '99+' : floor.objectCount}
                  </Tag>
                )}
              </Button>
            );
          })}
        </Space>
      )}
      <div style={{ marginTop: 10 }}>
        <Text type="secondary" style={{ fontSize: 12 }}>
          建物モードでは、フロアをクリックして切り替えできます。
        </Text>
      </div>
    </Card>
  );
}
